import React from "react";
import {ListEditor} from "../../components/list-editor";
import * as yup from "yup";
import {
    RegionType,
    useRegionTypesQueryQuery,
    useUpdateRegionTypesMutation,
    RegionTypesQueryQuery
} from '../../generated/graphql';
import {FieldTableColumnProps} from 'components/FieldTable/FieldTableTypes';
import {Tooltip} from "@mui/material";
import {useLocation} from "react-router";
import {FieldTableTitleTooltip} from "../../components/FieldTable/FieldTableTitleTooltip";
import {RegionTypeSelect} from "../../components/MaterialSelects/RegionTypeSelect";
import {RegionTypePricingModel} from "../../components/MaterialSelects/RegionTypePricingModel";
import {uniqueId} from "../../utils";


const columns: FieldTableColumnProps<RegionType>[] = [{
    header: 'Name',
    accessor: 'name',
    dataType: 'text',
}, {
    headerRaw: 'Has Poster Pricing?',
    header: <Tooltip title="Has poster pricing?"><FieldTableTitleTooltip>Has Poster Pricing</FieldTableTitleTooltip>
    </Tooltip>,
    accessor: 'has_poster_pricing',
    dataType: 'boolean',

},  {
    headerRaw: 'Has Split Qty?',
    header: <Tooltip title="Has quantity split into sites and per-site values?"><FieldTableTitleTooltip>Has Split Qty</FieldTableTitleTooltip>
    </Tooltip>,
    accessor: 'has_split_qty',
    dataType: 'boolean',

},  {
    headerRaw: 'Has Regional Pricing?',
    header: <Tooltip title="Pricing is changed on a per-region basis, rather than one set for the region type"><FieldTableTitleTooltip>Regional Pricing</FieldTableTitleTooltip>
    </Tooltip>,
    accessor: 'has_regional_pricing',
    dataType: 'boolean',

},{
    headerRaw: 'Pricing Model',
    header: <Tooltip title="Pricing model - beware changing this will affect any campaigns currently in QUOTE state"><FieldTableTitleTooltip>Pricing Model</FieldTableTitleTooltip></Tooltip>,
    accessor: 'pricing_model',
    dataType: 'text',
    options:{
        renderEditor:({field})=><RegionTypePricingModel {...field} valueIsId={true}/>
    }
}
];


function newRow(): RegionType {
    return {
        id: uniqueId(),
        name: '',
        pricing_model:'standard',
        has_poster_pricing:true
    };
}

const schema =  yup.array().of(
    yup.object().shape({
        'pricing_model': yup.string().required(),
        'name': yup.string().required()
    }));

function getValues(query: RegionTypesQueryQuery): RegionType[] {
    // query.data or whatever is stored in the object
    return query?.regionTypes.data;
}

const relationships = {
    'regionType': 'connect'
};

const RegionTypes = () => {
    const url = useLocation().pathname;
    const regionsQuery = useRegionTypesQueryQuery();
    const [mutation, mutationResult] = useUpdateRegionTypesMutation();
    return (
        <ListEditor
            columns={columns}
            validationSchema={schema}
            title="Region Types"
            permission="regional"
            query={regionsQuery}
            newRow={newRow}
            newRowLabel="Add Region Type"
            baseUrl={url}
            getValues={getValues}
            className="regions"
            relationships={relationships}
            saveResult={mutationResult}
            mutation={mutation}
        />);
}

export default RegionTypes;
